import React, { Component } from "react";
import { AxiosGetSecretApi } from "../../../../../utils/fetchApi";
import { connect } from "react-redux";
import { message } from "antd";
import StaticClass from "../../../../../utils/staticClass";

class SearchResult10000 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "DuAn",
      data: {},
    };

    this.listDuAnTitle = [
      "Mã loại đất",
      "Tên loại đất",
      "MĐSD cũ",
      "Năm quy hoạch",
      "Mặt bằng",
      "Diện tích (ha)",
      "Số quyết định",
    ];

    this.listDuAnValue = [
      "MaLoaiPolygon",
      "TenLoaiDat",
      "MDSDCu",
      "NamQH",
      "LoaiQH",
      "DienTich",
      "QuyetDinh",
    ];
  }

  changeTab(e) {
    this.setState({
      activeTab: e,
    });
  }
  componentDidMount() {
    this.getDataDuAn();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.data !== this.props.data) {
      this.getDataDuAn();
    }
  }

  async getDataDuAn() {
    if (this.props.data && this.props.data.OBJECTID) {
      let res;
      if(this.props.isEnableLayer?.includes('QHC_Test')){
        res = await AxiosGetSecretApi(
          `/api/qh-chung/search?curPage=1&pageSize=10&OBJECTID=${this.props.data.OBJECTID}&NamQH=2020`
        );
      }else{
        res = await AxiosGetSecretApi(
          `/api/qh-chung/search?curPage=1&pageSize=10&OBJECTID=${this.props.data.OBJECTID}`
        );
      }
      if (
        res &&
        res.dataResult &&
        Array.isArray(res.dataResult) &&
        res.dataResult.length > 0
      ) {
        this.setState({
          data: res.dataResult[0],
          isRender: true,
        });
        this.getGeoData(res.dataResult[0].OBJECTID, res.dataResult[0].LoaiQH);
      } else {
        this.setState({
          data: this.props.data,
        });
        message.error("Chưa có thông tin");
      }
    }
  }

  async getGeoData(id, type) {
    let url = "";
    if(this.props.isEnableLayer?.includes('QHC_Test')){
      url = `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/MatBangQHChung_Test/MapServer/0/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`;
    }else{
      if (type === "Hiện trạng") {
        url = `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/MatBangPolygon_HienTrang/MapServer/0/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`;
      } else {
        url = `https://gis-quyhoach.greenglobal.vn/server/rest/services/SoXayDung/QuyHoachDoThi/MapServer/5/query?f=json&where=1%3D1&returnGeometry=true&spatialRel=esriSpatialRelIntersects&objectIds=${id}&outFields=*&outSR=102100`;
      }
    }


    let res = await AxiosGetSecretApi(url);
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].geometry &&
      res.features[0].geometry.rings
    )
      this.props.drawRing(res.features[0].geometry.rings);
  }

  render() {
    return (
      <>
        {this.state.isRender && (
          <div className="search-result-lop-du-lieu">
            <div className="search-500-header">
              Thông tin quy hoạch chung 1/10000
              <i className="fas fa-times icon-close" onClick={this.props.close}></i>
            </div>

            <div className="search-500-body">
              {this.listDuAnTitle.map((e, i) => (
                <div style={{ display: "flex" }} key={i}>
                  <div className="col-left-10000 search-500-text" >
                    {e}:
                  </div>

                  <div className="col-right-10000 search-500-text-gray" >
                    {this.state.data[`${this.listDuAnValue[i]}`]
                      ? this.state.data[`${this.listDuAnValue[i]}`] !== "Null"
                        ? i === 5 
                          ? StaticClass.formatPrice(this.state.data[`${this.listDuAnValue[i]}`]) 
                          : this.state.data[`${this.listDuAnValue[i]}`]
                        : "-"
                      : "-"}
                  </div>
                </div>
              ))}

              {this.props.file && (
                <div style={{ display: "flex" }}>
                  <div className="col-left-10000 search-500-text">
                    File đính kèm:
                  </div>
                  <div>
                    {this.props.file.map((e, i) => (
                      <div
                        className="col-right-10000 search-500-text"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "125px",
                        }}
                      >
                        <a href={e.Duongdanfiledinhkem}>{e.Tenfiledinhkem}</a>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isEnableLayer: state.map.isEnableLayer,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResult10000);
